// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__30yD-","column":"style_column__9v6cz"};